import React from "react";
import { regionData } from "../../../../data/regionData";
import Text from "../Common/Text";
import ViewMore from "../Common/ViewMore";

const Region = () => {
  return (
    <div className="mt-8 px-2">
      <p className="font-pop text-base font-bold uppercase ">Region</p>
      <select
        name=""
        id=""
        className="my-2 w-full rounded-lg border border-darkGreen bg-transparent py-2 px-3"
      >
        <option value="">All</option>
        <option value="">North America</option>
        <option value="">Europe</option>
        <option value="">Asia</option>
        <option value="">South America</option>
        <option value="">Africa</option>
        <option value="">Australia</option>
      </select>
      <p className="font-sm font-pop font-bold text-darkGreen">South Africa</p>
      <div className="mt-4 flex flex-col gap-4 pl-4">
        {regionData.map((region) => (
          <Text text={region.name} amount={region.amount} />
        ))}
        <ViewMore />
      </div>
    </div>
  );
};

export default Region;
